const SecondaryWeapon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='46.715' height='20.637' viewBox='0 0 46.715 20.637' {...props}>
    <path
      id='Path_30792'
      data-name='Path 30792'
      d='M848.673,930.6h-8.985V928.44H825.163l-.246,2.631h-1.471l-1.529.994-.013.009v1.2h-2.769v-.389h-7.071l-.791-.65-.008-.007H809.34v12.865h1.4l7.067-7.067h1.331v-2.235H821.9v2.787l1.687,1.687-3.019,6.8-.012.027,4.475,1.987,3.154-6.337h5.181v-1.831h6.31l2.756-2.111h2.456l1.429,9.727,0,.03,3.95-.761.027-.005-1.432-9.746h2.379l.506.506h1.518V935.99h-4.6v-.906h7.382v-3.836h-7.382Z'
      transform='translate(-809.34 -928.44)'
      fill='currentColor'
    />
  </svg>
);
export default SecondaryWeapon;
